import React from 'react'
import {Link} from 'react-router-dom'
const PageNotFound = () => (
    <div>
        <h1>Page Not Found.</h1>
        <p>
            <Link to="/login">Login</Link>
        </p>
    </div>
)
export default PageNotFound;



// WEBPACK FOOTER //
// ./src/PageNotFound.js